import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AddressModel} from '../../../../../common/entity/address.model';
import {NavController} from '@ionic/angular';
import {AddressUtils} from '../../../../../../shared/utils/address.utils';
import {PartnerSummaryModel, PartnerType} from '../../model/partnerSummary.model';

@Component({
  selector: 'app-partner-summary',
  templateUrl: './partner-summary.component.html'
})
export class PartnerSummaryComponent implements OnInit, OnChanges {

  @Input() partnerName = undefined;
  @Input() partnerSummary: PartnerSummaryModel;
  @Input() button = false;
  @Input() lines = 'inset';
  @Input() href;
  @Input() strongLabel = true;
  @Input() displayTags = true;
  @Input() displayCreator = false;
  @Input() displayCreationDate = false;
  @Input() displayPartnerType = false;
  @Input() displayParentPartner = true;
  @Input() parentPartnerLabel = 'Parent';
  @Input() displayId = true;

  formattedPartnerName: string;
  tagEntityType: string;

  constructor(private navController: NavController) {
  }

  ngOnInit() {
    this.refreshFormattedPartnerName();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.partnerName || changes.partnerSummary) {
      this.refreshFormattedPartnerName();
    }
    if (changes.partnerSummary) {
      this.tagEntityType = this.partnerSummary?.tagEntityType;
    }
  }
  refreshFormattedPartnerName() {
    this.formattedPartnerName = this.partnerName ? this.partnerName : this.partnerSummary?.name;
  }

  click(){
    if (this.href) {
      this.navController.navigateForward(this.href);
    }
  }
}
